(function(){
var LOCALE=(document.documentElement.lang||'en').toLowerCase().split('-')[0];
var T={
  en:{
    weight_of:'Roughly the weight of',
    as_tall_as:'As tall as',
    ft_linear:'ft linear shelf',
    kallax_limit:'Limit:',
    kallax_yours:'Your vinyl:',
    over_spec:'over the 13 kg spec',
    kallax_warn_tail:'. Shelves bow. Backs warp. KTS is built for this.',
    cubes_safe_pre:'',
    cubes_safe_mid:'. At ',
    cubes_safe_within:', within the 13 kg limit. For now. Every 50 new records pushes you past it.',
    cube_word:'Kallax cube',
    cubes_word:'Kallax cubes',
    needed_open:' needed (',
    each_records:' records each). Each cube at ',
    avg_discogs:'Average Discogs collection:',
    records:'records',
    yours:'Yours:',
    top5:'Top 5% territory.',
    above_avg:'Above average. Growing fast.',
    keep_digging:'Keep digging.',
    listen_back:'Listening to everything back-to-back:',
    hours:'hours',
    thats:"That's",
    days_nonstop:'days non-stop.',
    carry_at_once:'Carrying it all at once =',
    deadlift:'More than most deadlifts. Get real furniture.',
    getting_heavy:'Getting heavy.',
    global_market:'Global vinyl market:',
    in_2025:'in 2025. Projected',
    by_2033:'by 2033. You\'re part of it.',
    replace_scratch:'Replacing from scratch at Discogs median:',
    worth_protecting:'Worth protecting.',
    n_records_need:'records need',
    of_shelf:'of shelf.',
    longer_rooms:'Longer than most rooms.',
    one_bookcase:'About one bookcase.',
    vinyl_outsold:'Vinyl out-earned CDs',
    units_2025:'in 2025. 46.8M units. 19 years of growth.',
    no_turntable:'40% of US vinyl buyers',
    no_turntable_tail:'They buy for the art, the ritual, the identity.',
    dont_own_tt:"don't own a turntable",
    share_text:'My vinyl collection (',
    share_records_weighs:'records) weighs',
    share_kg:'kg. How heavy is yours?',
    copy_done:'Copied!',
    copy_btn:'Copy Link',
    house_cat:'a house cat',
    dachshund:'a dachshund',
    bowling_ball:'a bowling ball',
    cocker:'a cocker spaniel',
    golden:'a golden retriever',
    labrador:'a Labrador',
    adult_person:'an adult person',
    barbell:'a loaded barbell',
    fridge:'a full refrigerator',
    grand_piano:'a grand piano',
    motorcycle:'a motorcycle',
    mc_rider:'a motorcycle + rider',
    small_car:'a small car',
    horse:'a horse',
    car:'a car',
    coffee_table:'a coffee table',
    counter:'a kitchen counter',
    avg_person:'the average person',
    door_frame:'a door frame',
    one_story:'a one-story ceiling',
    giraffe:'a giraffe',
    two_story:'a two-story house',
    four_story:'a four-story building',
    pisa:'the Leaning Tower of Pisa',
    liberty_pedestal:'the Statue of Liberty pedestal',
    liberty:'the Statue of Liberty',
    serious:'getting serious'
  },
  es:{
    weight_of:'Aproximadamente el peso de',
    as_tall_as:'Tan alto como',
    ft_linear:'pies de estante lineal',
    kallax_limit:'Límite:',
    kallax_yours:'Tus vinilos:',
    over_spec:'sobre el límite de 13 kg',
    kallax_warn_tail:'. Los estantes se doblan. Las traseras ceden. KTS está hecho para esto.',
    cubes_safe_pre:'',
    cubes_safe_mid:'. A ',
    cubes_safe_within:', dentro del límite de 13 kg. Por ahora. Cada 50 vinilos nuevos te acerca al borde.',
    cube_word:'cubo Kallax',
    cubes_word:'cubos Kallax',
    needed_open:' necesarios (',
    each_records:' vinilos cada uno). Cada cubo a ',
    avg_discogs:'Colección media en Discogs:',
    records:'vinilos',
    yours:'La tuya:',
    top5:'Top 5%.',
    above_avg:'Por encima de la media. Creciendo rápido.',
    keep_digging:'Sigue explorando.',
    listen_back:'Escuchar todo seguido:',
    hours:'horas',
    thats:'Eso es',
    days_nonstop:'días sin parar.',
    carry_at_once:'Llevarlos todos a la vez =',
    deadlift:'Más que un peso muerto. Necesitas muebles reales.',
    getting_heavy:'Pesa lo suyo.',
    global_market:'Mercado global del vinilo:',
    in_2025:'en 2025. Proyección',
    by_2033:'para 2033. Eres parte de ello.',
    replace_scratch:'Reponerla desde cero al precio mediano de Discogs:',
    worth_protecting:'Merece protección.',
    n_records_need:'vinilos necesitan',
    of_shelf:'de estantería.',
    longer_rooms:'Más largo que la mayoría de salas.',
    one_bookcase:'Como una librería.',
    vinyl_outsold:'En ingresos, el vinilo superó al CD',
    units_2025:'en 2025. 46,8M unidades. 19 años de crecimiento.',
    no_turntable:'El 40% de compradores de vinilo en EE.UU.',
    no_turntable_tail:'Compran por el arte, el ritual, la identidad.',
    dont_own_tt:'no tiene tocadiscos',
    share_text:'Mi colección de vinilos (',
    share_records_weighs:'vinilos) pesa',
    share_kg:'kg. ¿Cuánto pesa la tuya?',
    copy_done:'¡Copiado!',
    copy_btn:'Copiar enlace',
    house_cat:'un gato',
    dachshund:'un perro salchicha',
    bowling_ball:'una bola de bolos',
    cocker:'un cocker spaniel',
    golden:'un golden retriever',
    labrador:'un Labrador',
    adult_person:'una persona adulta',
    barbell:'una barra cargada de pesas',
    fridge:'una nevera llena',
    grand_piano:'un piano de cola',
    motorcycle:'una moto',
    mc_rider:'una moto + piloto',
    small_car:'un coche pequeño',
    horse:'un caballo',
    car:'un coche',
    coffee_table:'una mesa de centro',
    counter:'una encimera de cocina',
    avg_person:'una persona media',
    door_frame:'el marco de una puerta',
    one_story:'un techo de una planta',
    giraffe:'una jirafa',
    two_story:'una casa de dos plantas',
    four_story:'un edificio de cuatro plantas',
    pisa:'la Torre Inclinada de Pisa',
    liberty_pedestal:'el pedestal de la Estatua de la Libertad',
    liberty:'la Estatua de la Libertad',
    serious:'en serio'
  },
  de:{
    weight_of:'Etwa das Gewicht von',
    as_tall_as:'So hoch wie',
    ft_linear:'ft Regalmeter',
    kallax_limit:'Limit:',
    kallax_yours:'Dein Vinyl:',
    over_spec:'über dem 13 kg-Limit',
    kallax_warn_tail:'. Regale biegen sich. Rückwände wölben sich. KTS ist dafür gebaut.',
    cubes_safe_pre:'',
    cubes_safe_mid:'. Bei ',
    cubes_safe_within:', innerhalb des 13 kg-Limits. Vorerst. Alle 50 neuen Platten bringen dich näher heran.',
    cube_word:'Kallax-Würfel',
    cubes_word:'Kallax-Würfel',
    needed_open:' benötigt (',
    each_records:' Platten pro Stück). Jeder Würfel mit ',
    avg_discogs:'Durchschnittliche Discogs-Sammlung:',
    records:'Platten',
    yours:'Deine:',
    top5:'Top 5%.',
    above_avg:'Über dem Durchschnitt. Wächst schnell.',
    keep_digging:'Weitergraben.',
    listen_back:'Alles am Stück hören:',
    hours:'Stunden',
    thats:'Das sind',
    days_nonstop:'Tage durchgehend.',
    carry_at_once:'Alles auf einmal tragen =',
    deadlift:'Mehr als die meisten Kreuzheben. Hol dir echte Möbel.',
    getting_heavy:'Wird schwer.',
    global_market:'Globaler Vinyl-Markt:',
    in_2025:'in 2025. Projektion',
    by_2033:'bis 2033. Du bist Teil davon.',
    replace_scratch:'Neukauf zum Discogs-Median:',
    worth_protecting:'Schützenswert.',
    n_records_need:'Platten brauchen',
    of_shelf:'Regal.',
    longer_rooms:'Länger als die meisten Räume.',
    one_bookcase:'Etwa ein Bücherregal.',
    vinyl_outsold:'Beim Umsatz übertraf Vinyl die CDs',
    units_2025:'in 2025. 46,8M Stück. 19 Wachstumsjahre.',
    no_turntable:'40% der US-Vinyl-Käufer',
    no_turntable_tail:'Sie kaufen für die Kunst, das Ritual, die Identität.',
    dont_own_tt:'haben keinen Plattenspieler',
    share_text:'Meine Vinyl-Sammlung (',
    share_records_weighs:'Platten) wiegt',
    share_kg:'kg. Wie schwer ist deine?',
    copy_done:'Kopiert!',
    copy_btn:'Link kopieren',
    house_cat:'eine Hauskatze',
    dachshund:'ein Dackel',
    bowling_ball:'eine Bowlingkugel',
    cocker:'ein Cocker Spaniel',
    golden:'ein Golden Retriever',
    labrador:'ein Labrador',
    adult_person:'eine erwachsene Person',
    barbell:'eine voll beladene Hantel',
    fridge:'ein voller Kühlschrank',
    grand_piano:'ein Konzertflügel',
    motorcycle:'ein Motorrad',
    mc_rider:'ein Motorrad + Fahrer',
    small_car:'ein Kleinwagen',
    horse:'ein Pferd',
    car:'ein Auto',
    coffee_table:'ein Couchtisch',
    counter:'eine Küchentheke',
    avg_person:'eine Durchschnittsperson',
    door_frame:'ein Türrahmen',
    one_story:'eine einstöckige Decke',
    giraffe:'eine Giraffe',
    two_story:'ein zweistöckiges Haus',
    four_story:'ein vierstöckiges Gebäude',
    pisa:'der Schiefe Turm von Pisa',
    liberty_pedestal:'der Sockel der Freiheitsstatue',
    liberty:'die Freiheitsstatue',
    serious:'wird ernst'
  },
  fr:{
    weight_of:'Environ le poids de',
    as_tall_as:'Aussi haut que',
    ft_linear:'pieds linéaires',
    kallax_limit:'Limite :',
    kallax_yours:'Votre vinyle :',
    over_spec:'au-dessus de la limite de 13 kg',
    kallax_warn_tail:'. Les étagères ploient. Les fonds se voilent. KTS est conçu pour ça.',
    cubes_safe_pre:'',
    cubes_safe_mid:'. À ',
    cubes_safe_within:', dans la limite de 13 kg. Pour l\'instant. Tous les 50 nouveaux disques vous rapprochent.',
    cube_word:'cube Kallax',
    cubes_word:'cubes Kallax',
    needed_open:' nécessaires (',
    each_records:' disques chacun). Chaque cube à ',
    avg_discogs:'Collection moyenne Discogs :',
    records:'disques',
    yours:'La vôtre :',
    top5:'Top 5%.',
    above_avg:'Au-dessus de la moyenne. Croissance rapide.',
    keep_digging:'Continuez à creuser.',
    listen_back:'Tout écouter à la suite :',
    hours:'heures',
    thats:"C'est",
    days_nonstop:'jours non-stop.',
    carry_at_once:'Tout porter en une fois =',
    deadlift:'Plus que la plupart des soulevés de terre. Mobilier sérieux requis.',
    getting_heavy:'Ça devient lourd.',
    global_market:'Marché vinyle global :',
    in_2025:'en 2025. Projection',
    by_2033:"d'ici 2033. Vous en faites partie.",
    replace_scratch:'Remplacement total au prix médian Discogs :',
    worth_protecting:'Mérite protection.',
    n_records_need:'disques nécessitent',
    of_shelf:'d\'étagère.',
    longer_rooms:'Plus long que la plupart des pièces.',
    one_bookcase:'Environ une bibliothèque.',
    vinyl_outsold:'En chiffre d’affaires, le vinyle a dépassé les CD',
    units_2025:'en 2025. 46,8M unités. 19 ans de croissance.',
    no_turntable:'40% des acheteurs vinyles US',
    no_turntable_tail:"Ils achètent pour l'art, le rituel, l'identité.",
    dont_own_tt:"n'ont pas de platine",
    share_text:'Ma collection vinyle (',
    share_records_weighs:'disques) pèse',
    share_kg:'kg. Combien pèse la vôtre ?',
    copy_done:'Copié !',
    copy_btn:'Copier le lien',
    house_cat:'un chat',
    dachshund:'un teckel',
    bowling_ball:'une boule de bowling',
    cocker:'un cocker',
    golden:'un golden retriever',
    labrador:'un Labrador',
    adult_person:'un adulte',
    barbell:'une barre chargée',
    fridge:'un frigo plein',
    grand_piano:'un piano à queue',
    motorcycle:'une moto',
    mc_rider:'une moto + pilote',
    small_car:'une petite voiture',
    horse:'un cheval',
    car:'une voiture',
    coffee_table:'une table basse',
    counter:'un plan de travail',
    avg_person:'une personne moyenne',
    door_frame:'un cadre de porte',
    one_story:'un plafond de plain-pied',
    giraffe:'une girafe',
    two_story:'une maison à deux étages',
    four_story:'un immeuble de quatre étages',
    pisa:'la Tour de Pise',
    liberty_pedestal:'le piédestal de la Statue de la Liberté',
    liberty:'la Statue de la Liberté',
    serious:'devient sérieux'
  },
  it:{
    weight_of:'Circa il peso di',
    as_tall_as:'Alto come',
    ft_linear:'piedi lineari',
    kallax_limit:'Limite:',
    kallax_yours:'I tuoi vinili:',
    over_spec:'oltre il limite di 13 kg',
    kallax_warn_tail:'. Gli scaffali si piegano. Gli sfondi si deformano. KTS è costruito per questo.',
    cubes_safe_pre:'',
    cubes_safe_mid:'. A ',
    cubes_safe_within:', entro il limite di 13 kg. Per ora. Ogni 50 nuovi vinili ti avvicina.',
    cube_word:'cubo Kallax',
    cubes_word:'cubi Kallax',
    needed_open:' necessari (',
    each_records:' vinili ciascuno). Ogni cubo a ',
    avg_discogs:'Collezione media Discogs:',
    records:'vinili',
    yours:'La tua:',
    top5:'Top 5%.',
    above_avg:'Sopra la media. In rapida crescita.',
    keep_digging:'Continua a scavare.',
    listen_back:'Ascoltare tutto di fila:',
    hours:'ore',
    thats:'Sono',
    days_nonstop:'giorni di fila.',
    carry_at_once:'Portarli tutti insieme =',
    deadlift:'Più del peso massimo. Ti servono mobili veri.',
    getting_heavy:'Si fa pesante.',
    global_market:'Mercato globale del vinile:',
    in_2025:'nel 2025. Previsione',
    by_2033:'entro il 2033. Ne fai parte.',
    replace_scratch:'Rifare la collezione al prezzo mediano Discogs:',
    worth_protecting:'Vale la pena proteggerla.',
    n_records_need:'vinili richiedono',
    of_shelf:'di scaffale.',
    longer_rooms:'Più lungo della maggior parte delle stanze.',
    one_bookcase:'Circa una libreria.',
    vinyl_outsold:'Per fatturato, il vinile ha superato i CD',
    units_2025:'nel 2025. 46,8M unità. 19 anni di crescita.',
    no_turntable:'Il 40% degli acquirenti vinili USA',
    no_turntable_tail:"Comprano per l'arte, il rito, l'identità.",
    dont_own_tt:'non ha un giradischi',
    share_text:'La mia collezione di vinili (',
    share_records_weighs:'vinili) pesa',
    share_kg:'kg. Quanto pesa la tua?',
    copy_done:'Copiato!',
    copy_btn:'Copia link',
    house_cat:'un gatto',
    dachshund:'un bassotto',
    bowling_ball:'una palla da bowling',
    cocker:'un cocker',
    golden:'un golden retriever',
    labrador:'un Labrador',
    adult_person:'un adulto',
    barbell:'un bilanciere carico',
    fridge:'un frigo pieno',
    grand_piano:'un pianoforte a coda',
    motorcycle:'una moto',
    mc_rider:'una moto + pilota',
    small_car:'una piccola auto',
    horse:'un cavallo',
    car:'un\'auto',
    coffee_table:'un tavolino',
    counter:'un piano cucina',
    avg_person:'una persona media',
    door_frame:'lo stipite di una porta',
    one_story:'un soffitto al pianterreno',
    giraffe:'una giraffa',
    two_story:'una casa a due piani',
    four_story:'un edificio di quattro piani',
    pisa:'la Torre di Pisa',
    liberty_pedestal:'il piedistallo della Statua della Libertà',
    liberty:'la Statua della Libertà',
    serious:'fa sul serio'
  }
};
function tr(k){return (T[LOCALE]||T.en)[k]||T.en[k]||k}
var s=document.getElementById('slider'),m=document.getElementById('manualInput'),d=document.getElementById('countDisplay');
var comp=[
  {max:3,i:'\uD83D\uDC31',k:'house_cat'},
  {max:8,i:'\uD83D\uDC36',k:'dachshund'},
  {max:15,i:'\uD83C\uDFB3',k:'bowling_ball'},
  {max:25,i:'\uD83D\uDC36',k:'cocker'},
  {max:35,i:'\uD83D\uDC15',k:'golden'},
  {max:55,i:'\uD83E\uDDAE',k:'labrador'},
  {max:80,i:'\uD83E\uDDD1',k:'adult_person'},
  {max:120,i:'\uD83C\uDFCB\uFE0F',k:'barbell'},
  {max:150,i:'\u2744\uFE0F',k:'fridge'},
  {max:200,i:'\uD83C\uDFB9',k:'grand_piano'},
  {max:300,i:'\uD83C\uDFCD\uFE0F',k:'motorcycle'},
  {max:400,i:'\uD83C\uDFCD\uFE0F',k:'mc_rider'},
  {max:600,i:'\uD83D\uDE97',k:'small_car'},
  {max:1e3,i:'\uD83D\uDC0E',k:'horse'},
  {max:1/0,i:'\uD83D\uDE99',k:'car'}
];
var stk=[
  {max:.5,k:'coffee_table'},
  {max:1,k:'counter'},
  {max:1.7,k:'avg_person'},
  {max:2.5,k:'door_frame'},
  {max:3.5,k:'one_story'},
  {max:5,k:'giraffe'},
  {max:8,k:'two_story'},
  {max:14,k:'four_story'},
  {max:30,k:'pisa'},
  {max:50,k:'liberty_pedestal'},
  {max:100,k:'liberty'},
  {max:1/0,k:'serious'}
];
var reco=[
  {max:60,p:'The Crate',d:'Solid wood crate. Holds 50-60 LPs. Stack them as you grow. No particle board, no MDF.',l:'/products/classic-box-solid-wood-vinyl-storage-70-lps'},
  {max:100,p:'Vinyl Record Crate + Vinyl Break',d:'Crate holds 50-60 records flip-through style. The Break is your daily rotation stand. Pair them.',l:'/collections/vinyl-record-box'},
  {max:200,p:'Vinyl Modular (stack 2-3)',d:'Stackable solid wood modules, 50 LPs each. Stack two or three as your collection grows. Rated for real vinyl weight.',l:'/products/vinyl-modular-stackable-vinyl-record-storage-50-lps'},
  {max:400,p:'Vinyl Modular x4',d:'Four modules. Full wall unit. 200+ LPs. Most popular config among collectors with 200-400 records.',l:'/products/vinyl-stax-modular-x4'},
  {max:800,p:'Vinyl Modular x4 + Expansion',d:'Start with x4. Add modules as you grow. The system scales. Add a Digger\'s Wall for cabinet storage.',l:'/collections/vinyl-stax-modular'},
  {max:1/0,p:'Custom Configuration',d:'This size needs a storage wall. Combine Vinyl Modular towers with Digger\'s Wall and Crates for overflow.',l:'/collections/vinyl-record-storage'}
];
function gc(w){return comp.find(function(c){return w<=c.max})}
function gs(h){return stk.find(function(c){return h<=c.max})}
function gr(n){return reco.find(function(r){return n<=r.max})}
function f(n,x){x=x||1;return n>=1e3?n.toLocaleString('en-US',{maximumFractionDigits:0}):n.toFixed(x)}

var sticky=document.getElementById('stickyBar'),sliderEl=document.querySelector('.kts-slider');
var stickyVisible=false;
window.addEventListener('scroll',function(){
  if(!sliderEl)return;
  var r=sliderEl.getBoundingClientRect();
  var show=r.bottom<0;
  if(show!==stickyVisible){stickyVisible=show;sticky.classList.toggle('visible',show)}
},{passive:true});

function update(c){
  c=Math.max(1,Math.min(50000,parseInt(c)||1));
  d.textContent=c.toLocaleString('en-US');
  if(document.activeElement!==m)m.value=c;
  if(document.activeElement!==s)s.value=Math.min(2000,c);
  var p=((Math.min(c,2000)-10)/1990)*100;
  s.style.setProperty('--pct',p+'%');

  var wK=c*.25,wL=wK*2.20462,sM=c*.02,sF=sM*3.28084,hM=c*.007,v=c*25;

  document.getElementById('weightKg').textContent=f(wK)+' kg';
  document.getElementById('weightLbs').textContent=f(wL)+' lbs';
  var cm=gc(wK);
  document.getElementById('weightComparison').innerHTML='<span class="ktx-comparison-icon">'+cm.i+'</span><span class="ktx-comparison-text">'+tr('weight_of')+' <strong>'+tr(cm.k)+'</strong></span>';

  document.getElementById('shelfSpace').textContent=f(sM)+' m';
  document.getElementById('shelfFeet').textContent=f(sF)+' '+tr('ft_linear');
  document.getElementById('stackHeight').textContent=f(hM)+' m';
  var sc=gs(hM);
  document.getElementById('stackComparison').textContent=tr('as_tall_as')+' '+tr(sc.k)+' ('+f(hM*3.28084)+' ft)';
  document.getElementById('collValue').textContent='$'+v.toLocaleString('en-US');

  document.getElementById('stickyCount').textContent=c.toLocaleString();
  document.getElementById('stickyWeight').textContent=f(wK)+' kg';

  var rpc=55,cubes=Math.ceil(c/rpc),kgC=(c/cubes)*.25,kL=13;
  var oP=((kgC-kL)/kL*100);
  var kC=document.getElementById('kallaxCard'),fl=document.getElementById('kallaxFill');
  if(kC&&fl){
    var mB=Math.max(kL,kgC)*1.2,fP=(kgC/mB)*100,lP=(kL/mB)*100;
    var kLm=document.getElementById('kallaxLimit');if(kLm)kLm.style.left=lP+'%';
    fl.style.width=fP+'%';
    var kLl=document.getElementById('kallaxLimitLabel');if(kLl)kLl.textContent=tr('kallax_limit')+' '+kL+' kg/cube';
    var kAl=document.getElementById('kallaxActualLabel');if(kAl)kAl.textContent=tr('kallax_yours')+' '+f(kgC)+' kg/cube';
    var kT=document.getElementById('kallaxText');
    if(kT){
      var cubeWord=cubes>1?tr('cubes_word'):tr('cube_word');
      if(kgC>kL){
        kC.classList.remove('safe');
        fl.style.background='linear-gradient(90deg,var(--k-gold),var(--k-danger))';
        kT.innerHTML='<strong>'+cubes+' '+cubeWord+'</strong>'+tr('needed_open')+rpc+tr('each_records')+'<strong>'+f(kgC)+' kg</strong> \u2014 <strong style="color:var(--k-danger)">'+f(Math.abs(oP))+'% '+tr('over_spec')+'</strong>'+tr('kallax_warn_tail');
      }else{
        kC.classList.add('safe');
        fl.style.background='linear-gradient(90deg,var(--k-success),var(--k-gold))';
        kT.innerHTML='<strong>'+cubes+' '+cubeWord+'</strong>'+tr('cubes_safe_mid')+'<strong>'+f(kgC)+' kg/cube</strong>'+tr('cubes_safe_within');
      }
    }
  }

  var wdK=c*.05,oC=wdK*15,pC=wdK*4,sv=oC-pC;
  var co2El=document.getElementById('co2Saved');if(co2El)co2El.textContent=f(sv)+' kg CO2';

  var rc=gr(c);
  var rp=document.getElementById('recoProduct');if(rp)rp.textContent=rc.p;
  var rd=document.getElementById('recoDesc');if(rd)rd.textContent=rc.d;
  var rl=document.getElementById('recoLink');if(rl)rl.href=rc.l;

  var fa=[];
  fa.push({i:'\uD83D\uDCCA',t:tr('avg_discogs')+' <strong>195 '+tr('records')+'</strong>. '+tr('yours')+' <strong>'+c.toLocaleString()+'</strong>. '+(c>=500?tr('top5'):c>=195?tr('above_avg'):tr('keep_digging'))});
  fa.push({i:'\uD83C\uDFA7',t:tr('listen_back')+' <strong>'+f(c*44/60)+' '+tr('hours')+'</strong>. '+tr('thats')+' <strong>'+f(c*44/60/24)+'</strong> '+tr('days_nonstop')});
  if(c>=50)fa.push({i:'\uD83D\uDCAA',t:tr('carry_at_once')+' <strong>'+f(wK)+' kg</strong>. '+(wK>80?tr('deadlift'):tr('getting_heavy'))});
  if(c>=100)fa.push({i:'\uD83C\uDF0D',t:tr('global_market')+' <strong>$1.9B</strong> '+tr('in_2025')+' <strong>$3.5B</strong> '+tr('by_2033')});
  fa.push({i:'\uD83D\uDCB0',t:tr('replace_scratch')+' <strong>$'+v.toLocaleString()+'</strong>. '+tr('worth_protecting')});
  if(c>=200)fa.push({i:'\uD83C\uDFE0',t:c.toLocaleString()+' '+tr('n_records_need')+' <strong>'+f(sM)+' m</strong> '+tr('of_shelf')+' '+(sM>4?tr('longer_rooms'):tr('one_bookcase'))});
  fa.push({i:'\uD83D\uDE80',t:tr('vinyl_outsold')+' <strong>3:1</strong> '+tr('units_2025')});
  if(c>=300)fa.push({i:'\uD83C\uDFA8',t:tr('no_turntable')+' <strong>'+tr('dont_own_tt')+'</strong>. '+tr('no_turntable_tail')});

  var ff=document.getElementById('funFacts');
  if(ff)ff.innerHTML=fa.map(function(x){return '<div class="ktx-fact"><div class="ktx-fact-icon">'+x.i+'</div><div class="ktx-fact-text">'+x.t+'</div></div>'}).join('');
  updateShare(c,wK);
}

function updateShare(c,w){
  var url=window.location.origin+window.location.pathname;
  var txt=tr('share_text')+c.toLocaleString()+' '+tr('share_records_weighs')+' '+f(w)+' '+tr('share_kg');
  var bt=document.getElementById('shareTwitter');if(bt)bt.onclick=function(){window.open('https://twitter.com/intent/tweet?text='+encodeURIComponent(txt)+'&url='+encodeURIComponent(url),'_blank')};
  var bf=document.getElementById('shareFacebook');if(bf)bf.onclick=function(){window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url),'_blank')};
  var br=document.getElementById('shareReddit');if(br)br.onclick=function(){window.open('https://reddit.com/submit?url='+encodeURIComponent(url)+'&title='+encodeURIComponent(txt),'_blank')};
  var bc=document.getElementById('shareCopy');if(bc)bc.onclick=function(){var b=this;navigator.clipboard.writeText(url).then(function(){b.innerHTML='\u2713 '+tr('copy_done');setTimeout(function(){b.innerHTML='\uD83D\uDCCB '+tr('copy_btn')},2e3)})};
}

if(s){s.addEventListener('input',function(){update(this.value)});}
if(m){m.addEventListener('input',function(){var v=parseInt(this.value);if(v&&v>0)update(v)});
m.addEventListener('blur',function(){if(!this.value||parseInt(this.value)<1){this.value=10;update(10)}});}
update(200);
})();
